/* Import Section - Start */

/* React Imports - Start */

import React, { useState, useEffect } from "react";
import { useIsEdited } from "../../Providers/IsEditedProvider";


/* React Imports - End */

/* Plugin Imports - Start */

import { Checkbox } from "primereact/checkbox";

/* Plugin Imports - End */

/* Import Section - End */

/* Function - Start */

const CheckboxElement = (props) => {
  /* State Declaration - Start */

  /* useState - Start */
  const [checked, setCheckedValue] = useState(props.checked=== undefined? false: props.checked);
  const { setIsEdited } = useIsEdited();

  /* useState - End */
  
  /* State Declaration - End */
  
  /* useEffect - Start */
  
  useEffect(() => {
    setCheckedValue(props.checked);
  },[props.checked]);
  
  /* useEffect - End */
  
  /* Methods - Start */
  
  const checkValue = (e) => {
    setIsEdited(true);
    setCheckedValue(e.checked);
    props.onChangeCheck(e, props.inputId);
  };

  /* Methods - End */

  /* Render View Return - Start */

  return (
    <div className="p-field-checkbox">
      <Checkbox
        name={props.name}
        inputId={props.inputId}
        value={props.value}
        onChange={(e) => checkValue(e)}
        checked={checked || props.checked}
        disabled={props.disabled}
      />
      <label htmlFor={props.inputId} className="checkbox-label">
        {props.value}
      </label>
    </div>
  );

  /* Render View Return - End */
};
/* Function - End */

/* Export default functionName; */

export default CheckboxElement;
